(function() {
    'use strict';
    /*
     * Copyright (c) 2014-2019 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('campaignResourceMaterial', campaignResourceMaterial);

    function campaignResourceMaterial() {
        return {
            restrict: 'AE',
            transclude: true,
            scope: {
                /**
                 * If provided, the campaign is within the scope of this clinic; otherwise it is an IHH campaign.
                 */
                clinic: '=',

                /**
                 * An object with methods to query, create, read, update, and delete campaign resource materials.
                 */
                resourceMaterialsCrud: '=',

                /**
                 * An already initialized chooser config for resource materials.
                 */
                resourceMaterialsConfig: '=',

                episodeModel: '=',

                /**
                 * Indicates whether the resource materials are read only.
                 */
                isReadOnly: '='
            },
            controller: 'CampaignResourceMaterialCtrl',
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'campaign-resource-materials/campaign-resource-materials.tpl.html'
        };
    }
})();
